let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("byXlE")).then(() => parcelRequire('jERLI'));